import { render } from "./LoaderInsidePage.vue?vue&type=template&id=606b1ef2"
import script from "./LoaderInsidePage.vue?vue&type=script&lang=js"
export * from "./LoaderInsidePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__